import styled, { css } from 'styled-components'

const container = css`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
`

const item = css`
  box-sizing: border-box;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
`

const GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

function generateGrid(globalStyles, breakpoint, theme) {
  const styles = {}
  styles[breakpoint] = {}

  GRID_SIZES.forEach((size) => {
    if (size === true) {
      // For the auto layouting
      styles[breakpoint][size] = css`
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      `
      return
    }

    if (size === 'auto') {
      styles[breakpoint][size] = css`
        flex-basis: auto;
        flex-grow: 0;
        max-width: none;
      `
      return
    }

    // Keep 7 significant numbers
    const width = `${ Math.round((size / 12) * 10e7) / 10e5 }%`

    if (breakpoint === 'xs') {
      styles[breakpoint][size] = css`
        flex-basis: ${ width };
        flex-grow: 0;
        max-width: ${ width };
      `
    } else {
      styles[breakpoint][size] = css`
        @media (min-width: ${ theme.breakpoints.sizes[breakpoint] }px) {
          flex-basis: ${ width };
          flex-grow: 0;
          max-width: ${ width };
        }
      `
    }
    Object.assign(globalStyles, styles)
  })
}

function getOffset(val, div = 1) {
  const parse = parseFloat(val)
  return `${ parse / div }${ String(val).replace(String(parse), '') || 'px' }`
}

function generateGutter(globalStyles, theme) {
  const styles = {}

  SPACINGS.forEach((spacing) => {
    const themeSpacing = theme.spacing(spacing)

    if (themeSpacing === 0) {
      return
    }

    styles[`spacing-${ spacing }`] = css`
      margin: -${ getOffset(themeSpacing, 2) };
      width: calc(100% + ${ getOffset(themeSpacing) });
      & > div {
        padding: ${ getOffset(themeSpacing, 2) };
      }
    `
    Object.assign(globalStyles, styles)
  })
}

const getPrintStyle = (size) => css`
  @media print {
    flex-basis: calc(${ size } / 12 * 100%) !important;
    flex-grow: 0;
    max-width: calc(${ size } / 12 * 100%) !important;
  }
`

export const Root = styled.div.attrs((props) => {
  const styles = {}
  Object.keys(props.theme.breakpoints.sizes).forEach((breakpoint) => {
    generateGrid(styles, breakpoint, props.theme)
  })
  generateGutter(styles, props.theme)
  return {
    styles,
  }
})`
  ${ (props) => props.container && container }
  ${ (props) => props.item && item }
    ${ (props) => props.xs !== false && props.styles.xs[props.xs] }
    ${ (props) => props.sm !== false && props.styles.sm[props.sm] }
    ${ (props) => props.md !== false && props.styles.md[props.md] }
    ${ (props) => props.td !== false && props.styles.td[props.td] }
    ${ (props) => props.lg !== false && props.styles.lg[props.lg] }
    ${ (props) => props.xl !== false && props.styles.xl[props.xl] }
    ${ (props) => props.print !== false && getPrintStyle(props.print) }
    ${ (props) =>
    props.container &&
    props.spacing &&
    props.styles[`spacing-${ props.spacing }`] }
    ${ (props) =>
    props.container && props.alignItems && `align-items: ${ props.alignItems };` }
    ${ (props) =>
    props.container &&
    props.justifyContent &&
    `justify-content: ${ props.justifyContent };` }
    ${ (props) =>
    props.container &&
    props.containerHeight.value !== false &&
    `height: ${ props.containerHeight.value }${
      props.containerHeight.unit && props.containerHeight.unit
    };` }
    ${ (props) =>
    props.item && props.alignSelf && `align-self: ${ props.alignSelf };` }
`
